import React from 'react'
import CleverAppPreloader from '../Clever/components/AppPreloader'

const AppPreloader = (props) => <CleverAppPreloader {...props} />

export default AppPreloader
